import { z } from "zod";
import { onPremisePaidNewManagedPaymentZodObject } from "./on-premise-paid.new-managed-payment";
import { onPremisePayLaterNewManagedPaymentZodObject } from "./on-premise-pay-later.new-managed-payment";
import { payRequestNewManagedPaymentZodObject } from "./pay-request.new-managed-payment";

const newManagedPaymentZodDiscriminatedUnion = z.discriminatedUnion("_type", [
    z.object({
        _type: z.literal("NEW_MANAGED_PAYMENT__PAY_REQUEST"),
        payRequest: payRequestNewManagedPaymentZodObject,
        // discount: discountNewManagedPaymentZodObject.optional(),
    }),
    z.object({
        _type: z.literal("NEW_MANAGED_PAYMENT__ON_PREMISE_PAID"),
        onPremisePaid: onPremisePaidNewManagedPaymentZodObject,
        // discount: discountNewManagedPaymentZodObject.optional(),
    }),
    z.object({
        _type: z.literal("NEW_MANAGED_PAYMENT__ON_PREMISE_PAY_LATER"),
        onPremisePayLater: onPremisePayLaterNewManagedPaymentZodObject,
        // discount: discountNewManagedPaymentZodObject.optional(),
    }),
]);

type NewManagedPayment = z.infer<typeof newManagedPaymentZodDiscriminatedUnion>;
export { newManagedPaymentZodDiscriminatedUnion };
export type { NewManagedPayment };
